import { render, staticRenderFns } from "./filterColumns.vue?vue&type=template&id=65bff54e&scoped=true"
import script from "./filterColumns.vue?vue&type=script&lang=js"
export * from "./filterColumns.vue?vue&type=script&lang=js"
import style0 from "./filterColumns.vue?vue&type=style&index=0&id=65bff54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bff54e",
  null
  
)

export default component.exports